import {
  MONSTER_CONTENT,
  type MapRuntimeDefinition,
  type MonsterContentId,
} from "@ninja/game-content";

export interface RegionEncounterTimerAnchor {
  kind: "elite" | "boss";
  monsterId: MonsterContentId;
  x: number;
  y: number;
}

export function regionEncounterTimerAnchorsFor(
  map: MapRuntimeDefinition,
): RegionEncounterTimerAnchor[] {
  if (map.regionNavigation?.role !== "field") return [];

  const eliteSpawns = map.monsterSpawns.flatMap((spawn) =>
    MONSTER_CONTENT[spawn.monsterId]?.category === "elite"
      ? [
          {
            kind: "elite" as const,
            monsterId: spawn.monsterId,
            x: spawn.x,
            y: spawn.y,
          },
        ]
      : [],
  );
  const accessIds = new Set(
    (map.regionSpatial?.layers.zone_access ?? [])
      .map((access) => access.properties.accessId)
      .filter((accessId): accessId is string => typeof accessId === "string"),
  );
  const bossEntrances = (map.regionSpatial?.layers.boss_entrances ?? [])
    .filter((entry) => {
      const accessId = entry.properties.accessId;
      const contentId = entry.properties.contentId;
      return (
        typeof accessId === "string" &&
        accessIds.has(accessId) &&
        typeof contentId === "string" &&
        contentId in MONSTER_CONTENT &&
        MONSTER_CONTENT[contentId as MonsterContentId]?.category === "boss"
      );
    })
    .map((entry) => ({
      kind: "boss" as const,
      monsterId: entry.properties.contentId as MonsterContentId,
      x: entry.x,
      y: entry.y,
    }));

  return [...eliteSpawns, ...bossEntrances];
}
